<template>
  <div>
    <custom-callout
      apply-border-top
      has-border
      has-toggle
      has-gradient
      controlled
      :border-color="item.status.color"
      :opened="item.isOpen"
      @click:open="() => toggle(false)"
    >
      <div class="row pt-3">
        <div
          class="col-12 col-lg-2 border-right d-flex flex-column justify-content-center align-items-center"
        >
          <custom-balloon
            dot
            :text="item.status.name"
            :background-color="item.status.color"
          />
          <span>{{ item.planActionType?.name | empty }}</span>
          <span>{{ item.code | empty }}</span>
        </div>
        <div class="col-12 col-lg ml-3">
          <div class="row justify-content-center align-items-center">
            <div class="col-12 col-lg-4 mb-3">
              <custom-input-display
                label="Categoría de la Alternativa:"
                label-class="text-gray font-weight-light"
                :value="item.alternativeCategory?.name"
                class="span-student ml-0"
              />
            </div>
            <div class="col-12 col-lg-4 mb-3">
              <custom-input-display
                label="Nombre de la Alternativa:"
                label-class="text-gray font-weight-light"
                :value="item.alternative?.name"
                class="span-student ml-0"
              />
            </div>
            <div class="col-12 col-lg-4 mb-3">
              <custom-input-display
                label="Nivel de Prioridad:"
                label-class="text-gray font-weight-light"
                :value="item.priorityLevel?.name"
                class="span-student ml-0"
              />
            </div>
          </div>
          <div class="row border-top">
            <div class="col-12 col-lg-4 mt-3">
              <custom-input-display
                label="Centro:"
                label-class="text-gray font-weight-light"
                :value="item.center?.name"
                class="span-student ml-0"
              />
            </div>
            <div class="col-12 col-lg-4 mt-3">
              <custom-input-display
                label="Municipio:"
                label-class="text-gray font-weight-light"
                :value="item.municipality?.name"
                class="span-student ml-0"
              />
            </div>
            <div class="col-12 col-lg-4 mt-3">
              <custom-input-display
                label="Escuela:"
                label-class="text-gray font-weight-light"
                :value="item.school?.name"
                class="span-student ml-0"
              />
            </div>
          </div>
        </div>
        <div
          class="col-12 col-lg-2 d-flex justify-content-center align-items-center"
        >
          <drop-down always-show-dropdown :items="actionItems" />
        </div>
      </div>
      <template #edition>
        <div class="bg-gray p-2">
          <div class="bg-white p-3 rounded">
            <!-- editions -->
            <div v-if="isAssignPriorityVisible">
              <assign-priority
                :value="{ priorityLevel: item.priorityLevel }"
                :options="priorityLevels"
                @save="savePriority"
                @cancel="toggle(false)"
              />
            </div>
            <div v-else-if="isVisibleFollowUp">
              <follow-up
                :initial-data="item.followup"
                :is-from-previous="isFromPrevious"
                :academic-year-id="academicYearId"
                @save="handleSaveFollowUp"
                @cancel="toggle(false)"
              />
            </div>
            <div v-else-if="isVisibleYearClosing">
              <year-closing
                :initial-data="item.followup"
                @save="handleSaveYearClosing"
                @cancel="toggle(false)"
              />
            </div>
            <div v-else-if="isNoActionVisible">
              <disabled-action
                @save="handleNoActionStatus"
                @cancel="toggle(false)"
              />
            </div>
            <div v-else-if="isHistoryVisible">
              <history
                :pagination="history"
                @search="searchHistory"
                @close="toggle(false)"
              />
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomInputDisplay from 'CustomInputDisplay';
import ActionButton from 'ActionButton';
import CustomBalloon from 'custom-balloon';
import DropDown from 'dropdown';

//mixins
import mixAlert from '@/mixin/alert.mixin';

// services
import {
  getLatestFollowup as _getLatestFollowup,
  saveFollowUp as _saveFollowUp,
  saveYearClosing as _saveYearClosing,
  patch,
  setNoActionStatus as _setNoActionStatus,
  getHistory,
} from '@/services/operations/action-plan.js';

// child components
import FollowUp from './FollowUp.vue';
import YearClosing from './YearClosing.vue';
import AssignPriority from './AssignPriority.vue';
import DisabledAction from './DisabledAction.vue';
import History from './History.vue';

// constants
import Statuses from '@/utils/constants/tapRequest/alternativeLocationActionPlanStatus.js';
import item from '@/utils/constants/inventory/inventoryOrderBookTransferReasons';

const ACTIONS = {
  FOLLOW_UP: 'FOLLOW_UP',
  YEAR_CLOSING: 'YEAR_CLOSING',
  ASSIGN_PRIORITY: 'ASSIGN_PRIORITY',
  NO_ACTION: 'NO_ACTION',
  HISTORY: 'HISTORY',
};

export default {
  name: 'ParticipantRow',
  components: {
    CustomCallout,
    CustomInputDisplay,
    ActionButton,
    CustomBalloon,
    DropDown,
    AssignPriority,
    FollowUp,
    YearClosing,
    DisabledAction,
    History,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: () => 0,
    },
    academicYearId: {
      type: Number,
      default: () => 0,
    },
    priorityLevels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      action: null,
      history: {
        count: 0,
        currentPage: 1,
        pageCount: 1,
        totalItemCount: 0,
        data: [],
      },
    };
  },
  computed: {
    actions() {
      return ACTIONS;
    },
    actionItems() {
      return [
        {
          name: 'Editar',
          icon: 'fas fa-pen text-green',
          visible: this.isDraft,
          click: this.edit,
        },
        {
          name: 'Entrar',
          icon: 'fas fa-file-import text-green',
          visible: this.isEnterActionVisible,
          click: this.enter,
        },
        {
          name: 'Asignar Prioridad',
          icon: 'fas fa-list text-green',
          visible: this.canAssignPriority,
          click: () => this.toggle(true, ACTIONS.ASSIGN_PRIORITY),
        },
        {
          name: 'Dar Seguimiento',
          icon: 'fas fa-file-invoice text-green',
          visible: this.canFollowUp,
          click: () => this.toggle(true, ACTIONS.FOLLOW_UP),
        },
        {
          name: 'Histórico Seguimiento de Plan',
          icon: 'fas fa-history text-green',
          visible: this.canViewFollowUpHistory,
          click: this.handleGoToFollowUpHistory,
        },
        {
          name: 'Historial de Estatus',
          icon: 'fas fa-clock text-green',
          click: this.searchHistory,
        },
        {
          name: 'Cierre de Año',
          icon: 'fas fa-calendar-alt text-green',
          visible: this.canYearClosing,
          click: () => this.toggle(true, ACTIONS.YEAR_CLOSING),
        },
        {
          name: 'Dejar sin Acción',
          icon: 'fas fa-ban text-muted',
          visible: this.isNoActionButtonVisible,
          click: () => this.toggle(true, ACTIONS.NO_ACTION),
        },
      ];
    },
    actionPlanId() {
      return this.item.id;
    },
    actionPlanAcademicYearId() {
      return this.item.academicYear.id;
    },
    isFromPrevious() {
      return this.academicYearId != this.item.academicYear.id;
    },
    isDraft() {
      return this.item.status.id === Statuses.Borrador;
    },
    isEnterActionVisible() {
      return [
        Statuses.Extendido,
        Statuses.Sometido,
        Statuses.EnProceso,
        Statuses.NoAmeritaAccion,
        Statuses.Atendido,
      ].includes(this.item.status.id);
    },
    isNoActionButtonVisible() {
      return (
        [
          Statuses.Extendido,
          Statuses.Sometido,
          Statuses.EnProceso,
          Statuses.Borrador,
        ].includes(this.item.status.id) && this.item.canDoFollowUp
      );
    },
    isSubmitted() {
      return this.item.status.id === Statuses.Sometido;
    },
    canAssignPriority() {
      return (
        ![Statuses.NoAmeritaAccion, Statuses.Atendido].includes(
          this.item.status.id
        ) && this.item.canDoFollowUp
      );
    },
    canFollowUp() {
      return (
        ![
          Statuses.Borrador,
          Statuses.Atendido,
          Statuses.NoAmeritaAccion,
        ].includes(this.item.status.id) &&
        !!this.item.priorityLevel &&
        this.item.canDoFollowUp
      );
    },
    canYearClosing() {
      return (
        [Statuses.EnProceso, Statuses.Extendido].includes(
          this.item.status.id
        ) && this.item.canDoFollowUp
      );
    },
    canViewFollowUpHistory() {
      return [
        Statuses.NoAmeritaAccion,
        Statuses.Sometido,
        Statuses.EnProceso,
        Statuses.Atendido,
        Statuses.Extendido,
      ].includes(this.item.status.id);
    },
    isAssignPriorityVisible() {
      return this.action === ACTIONS.ASSIGN_PRIORITY;
    },
    isNoActionVisible() {
      return this.action === ACTIONS.NO_ACTION;
    },
    isVisibleFollowUp() {
      return this.action === ACTIONS.FOLLOW_UP;
    },
    isVisibleYearClosing() {
      return this.action === ACTIONS.YEAR_CLOSING;
    },
    isHistoryVisible() {
      return this.action === ACTIONS.HISTORY;
    },
  },
  methods: {
    async toggle(opened = !this.item.isOpen, action) {
      if (
        opened &&
        [ACTIONS.FOLLOW_UP, ACTIONS.YEAR_CLOSING].includes(action)
      ) {
        const followupData =
          (await _getLatestFollowup(this.actionPlanId, this.academicYearId))
            ?.data || {};
        this.setItemData({ followup: followupData });
      }
      this.action = action;
      this.item.isOpen = opened;
      this.$emit('toggle', this.item);
    },
    enter() {
      const {
        academicYear,
        id: actionPlanId,
        schoolAlternativeLocation,
      } = this.item;
      this.$router.push({
        name: 'location-alternatives-action-plan',
        params: {
          academicYearId: academicYear.id,
          schoolAlternativeLocationId: schoolAlternativeLocation?.id ?? 'null',
          actionPlanId,
        },
      });
    },
    edit() {
      const { academicYear, id: actionPlanId } = this.item;
      this.$router.push({
        name: 'location-alternatives-action-plan',
        params: {
          academicYearId: academicYear.id,
          schoolAlternativeLocationId: 'null',
          actionPlanId,
        },
      });
    },
    async savePriority({ priorityLevel }) {
      if (!priorityLevel) return;
      try {
        if (priorityLevel.id !== this.item.priorityLevel?.id) {
          await patch(this.item.id, { priorityLevelId: priorityLevel.id });
          this.item.priorityLevel = priorityLevel;
        }
        this.toggle(false);
        this.ShowToast(
          '',
          'El nivel de prioridad ha sido asignado correctamente.',
          'success'
        );
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
      }
    },
    refresh() {
      this.$emit('refresh');
    },
    setItemData(data) {
      Object.keys(data).forEach((key) => {
        this.$set(this.item, key, data[key]);
      });
    },
    async handleSaveFollowUp({ questions, staffName, staffPositionNumber, comment }) {
      const questionMap = Object.fromEntries(
        questions.map((question) => [question.name, question.value])
      );
      const payload = {
        ...questionMap,
        staffName,
        staffPositionNumber,
        actionPlanId: this.actionPlanId,
        academicYearId: this.academicYearId,
        comment,
      };
      const response = await _saveFollowUp(payload).catch((err) => {
        this.ShowToast('Error', err.response.data.message, 'error');
      });
      if (response?.data) {
        this.ShowToast(
          'Éxito',
          'El seguimiento fue guardado correctamente.',
          'success'
        );
        this.toggle(false);
        this.refresh();
      }
    },
    async handleSaveYearClosing(data) {
      const payload = {
        ...data,
        academicYearId: this.academicYearId,
        actionPlanId: this.actionPlanId,
        followUpId: this.item.followup?.followUpId,
      };
      const response = await _saveYearClosing(payload).catch((err) => {
        this.ShowToast('Error', err.response.data.message, 'error');
      });
      if (response?.data) {
        this.ShowToast(
          '',
          'El cierre de año fue guardado correctamente.',
          'success'
        );
        this.toggle(false);
        this.refresh();
      }
    },
    handleGoToFollowUpHistory() {
      this.$router.push({
        name: 'action-plan-followup-history',
        params: {
          actionPlanId: this.actionPlanId,
          academicYearId: this.academicYearId,
          isFromPrevious: this.isFromPrevious,
        },
      });
    },
    async handleNoActionStatus(comment) {
      const payload = {
        comment: comment,
        id: this.item.id,
      };

      try {
        await _setNoActionStatus(payload);
        this.ShowToast('', 'Se ha actualizado correctamente.', 'success');
        this.toggle(false);
        this.refresh();
      } catch (err) {
        this.ShowToast(
          'Error',
          err.response?.data?.message || 'Error inesperado',
          'error'
        );
      }
    },
    async searchHistory(currentPage = 1, pageSize = 5) {
      const params = { currentPage, pageSize };
      const { data } = await getHistory(this.actionPlanId, params);
      this.history = { ...data, pageSize };
      this.toggle(true, ACTIONS.HISTORY);
    },
  },
};
</script>
